var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"account-plan-create-edit"}},[_c('div',{staticClass:"page page--accounts"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"h2"},[_vm._v("Oops, Page not found.")]),_c('hr')])])])])
}]

export { render, staticRenderFns }